import { Component, OnInit } from '@angular/core';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';

@Component({
    selector: 'app-user-header',
    templateUrl: './user-header.component.html',
    styleUrls: ['./user-header.component.less'],
    standalone: false
})
export class UserHeaderComponent implements OnInit {

  externalSettings! : ExternalSettings;
  colorButtonBackground!: Record<string, string>;

  constructor(private srvES : ExternalSettingsService) { 


  }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((value) => {
      this.colorButtonBackground = {
        'background-color': value.web.color_buttonbackground,
        'border-color' : value.web.color_buttonbackground
      }
    })
  }

  

}
